import type { MessagingGetChatMessages200PageAllOf } from './messagingGetChatMessages200PageAllOf';
import type { MessagingGetChatMessages200PageAllOfThree } from './messagingGetChatMessages200PageAllOfThree';

export type MessagingGetChatMessages200Page = MessagingGetChatMessages200PageAllOf & MessagingGetChatMessages200PageAllOfThree;
